import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { ProductsService } from 'src/app/shared/services/products.service';

@Component({
	selector: 'app-journee-securite-workshops',
	templateUrl: './journee-securite-workshops.component.html',
	styleUrls: ['../journee-securite/journee-securite.component.scss'],
})
export class JourneeSecuriteWorkshopsComponent implements OnInit {

    workshops = []
    workshopsNb = 0
    loading = true

	constructor(public language: LanguageService,private productService: ProductsService,) {}

	ngOnInit(): void {
        this.loadWorkshops()
    }

    loadWorkshops(){
        this.loading = true
        this.productService.searchProducts(null, [221], this.workshops.length, 24)
        .then((workshops)=>{
            this.workshops = this.workshops.concat(this.productService.setProductsInfos(workshops['datas'],null,null))
            this.workshopsNb = workshops['quantity']
            this.loading = false
        })
    }
}
